import { EV } from 'enerx-shared';
import { useLineItemPhotos } from 'model/photos';
import { AttachedPhotos } from 'views/common/AttachedPhotos';

export const LineItemPhotos = ({ mode, auditFsid, lineItem }: { mode: 'photos' | 'camera', auditFsid: string, lineItem: EV.IOnsiteAuditLineItem }) => {
    const photoModel = useLineItemPhotos(auditFsid, lineItem);
    return <AttachedPhotos model={photoModel} mode={mode} />
}
